module.exports = __webpack_public_path__ + "img/succeed@2x.a090b719.png";